import { useWindowSize } from "@hooks/useWindowSize";
import Card from "@particles/card/Card";
import { CardVariations, TemplateProps } from "@particles/card/utils/types";
import { cn } from "@util/helpers";

/**
 * This is the template B of cards. Used to display 3 cards in a row.
 * @figma https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/BAU--WEB-?node-id=12726-24123&m=dev
 */
const TemplateB = ({
  className,
  header,
  cardProps,
  cardVariantOverride,
}: TemplateProps): React.ReactElement => {
  const { isScreenMD } = useWindowSize();
  const variant: CardVariations = {
    kicker: {
      color: "text-blue-175",
      extraClass: cn("font-freightSansPro text-base mb-1 md:mb-0"),
    },
    title: {
      color: "text-gray-850",
      size: cn("text-xl font-lct font-semibold -tracking-2% mb-2 md:mb-1"),
    },
    image: {
      position: "",
      width: cn("w-[7.5rem] md:w-full"),
      aspectRatio: "aspect-3x2",
      imageClassName: cn("object-cover"),
      extraClass: cn("order-2 md:order-1"),
      orientation: "landscape",
    },
    content: {
      width: cn("w-[calc(100%-7.5rem)] md:w-full"),
      extraClass: cn("pr-3 md:pt-3 order-1 md:order-2"),
      blurb: {
        extraClass: cn(
          "text-gray-750 font-lucida text-base font-medium leading-normal -tracking-5% !line-clamp-5"
        ),
      },
    },
  };

  if (cardProps.length === 0) return <></>;

  return (
    <div
      data-testid="card-template-component"
      data-template="template-b"
      className={className}
    >
      {header}

      <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {cardProps.map((props, index) => {
          return (
            <Card
              key={props.link + props.title}
              {...props}
              displayAsTopTitle={!isScreenMD}
              variations={cardVariantOverride || variant}
              className={cn("relative md:flex-col", {
                "after:absolute after:-bottom-4 after:h-[1px] after:w-full after:bg-blue-100 md:after:-right-4 md:after:bottom-0 md:after:top-0 md:after:h-full md:after:w-[1px] md:after:bg-blue-100":
                  [0, 1].includes(index),
              })}
            />
          );
        })}
      </div>
    </div>
  );
};

export default TemplateB;
